module.exports = __webpack_public_path__ + "static/landing-bg-da64acf684eb1473a861c463756a21dd.png";